import { render, staticRenderFns } from "./Collaborate-with.vue?vue&type=template&id=edb27d8a&scoped=true"
var script = {}
import style0 from "./Collaborate-with.vue?vue&type=style&index=0&id=edb27d8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edb27d8a",
  null
  
)

export default component.exports